import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { getCustomerMergeInfo, PostCustomerMergeInfo } from '../../../../actions/customers'

// Elements
import Radio from '../../../elements/radio'
import LabelWrapper from '../../../elements/labelWrapper'
import Inline from '../../../elements/inline'
import DropDown from '../../../elements/dropDown'
import Divider from '../../../elements/divider'

// Utils
import { translation } from '../../../../utils/helpers'
import Grid from '../../../elements/grid'

class MigrationInfo extends Component {
  constructor (props) {
    super(props)

    this.state = {
      Customer: {},
      PrimaryCompanyName: '',
      Customers: [],
      UsedCustomerIds: [],
      SelectedCustomerId: 0,
      NewCustomer: false,
      OtherCustomer: false,
      BookingType: null
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onSave = this.onSave.bind(this)
    this.getData = this.getData.bind(this)
  }

  componentDidMount () {
    this.getData(this.props.customerId)
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.NewCustomer !== this.state.NewCustomer ||
      prevState.SelectedCustomerId !== this.state.SelectedCustomerId ||
      prevState.BookingType !== this.state.BookingType) {
      if (this.props.setBottomBarProps) {
        this.props.setBottomBarProps({
          disabled: this.state.NewCustomer === false && (this.state.SelectedCustomerId <= 0 || this.state.BookingType === null),
          actionLabelText: translation(791),
          onActionClick: this.onSave
        })
      }
    }
  }

  componentWillReceiveProps (next) {
    if (this.props.customerId !== next.customerId) {
      this.getData(next.customerId)
    }
  }

  getData (customerId) {
    if (isNaN(customerId) || customerId <= 0) return

    this.props.getCustomerMergeInfo(customerId).then(res => {
      this.setState({
        Customer: res.data.Customer,
        Customers: res.data.Customers,
        PrimaryCompanyName: res.data.PrimaryCompanyName,
        UsedCustomerIds: res.data.UsedCustomerIds
      })
    })
  }

  onInputChange (e, isTop) {
    if (e.target === undefined) e = isTop

    let targetName = e.target.name
    let value = e.target.value
    let extra = { BookingType: null }

    if (targetName === 'NewCustomer') {
      value = true
      extra = { OtherCustomer: false, SelectedCustomerId: 0, BookingType: null }
    } else if (targetName === 'OtherCustomer') {
      value = true
      extra = { NewCustomer: false, SelectedCustomerId: 0, BookingType: null }
    } else if (isTop) {
      extra = { NewCustomer: false, OtherCustomer: false, BookingType: null }
    }

    this.setState({
      ...extra,
      [targetName]: value
    })
  }

  onSave () {
    let data = {
      SourceCustomerId: this.state.Customer.CustomerId,
      DestinationCustomerId: this.state.SelectedCustomerId,
      BookingType: this.state.BookingType,
      IsNewCustomer: this.state.NewCustomer
    }

    this.props.PostCustomerMergeInfo(data).then(() => {
      this.props.onClose()
    })
  }

  render () {
    const renderTopCustomers = () => {
      let customers = this.state.Customers
      if (customers.length === 0) return

      const renderTopCustomerItem = (item, key) => {
        let isSelected = item.CustomerId === Number(this.state.SelectedCustomerId)
        return <Radio
          labelText={[
            <span>{item.Name}</span>,
            <span>{translation(16412).replace('[x]', item.Count)}</span>
          ]}
          name='SelectedCustomerId'
          value={item.CustomerId}
          onChange={this.onInputChange.bind(this, true)}
          checked={isSelected}
        />
      }

      return customers.map(renderTopCustomerItem)
    }

    const renderCustomerSelect = () => {
      let options = [{ label: translation('2259'), value: 0 }]
      this.props.customers
          .filter(c => c.Active && !c.IsApromasWorkshop && !c.IsPerformingCustomer && !this.state.Customers.some(x => x.CustomerId === c.CustomerId) && !this.state.UsedCustomerIds.some(x => x === c.CustomerId))
          .map((c, i) => options.push({ label: c.Name, value: c.CustomerId }))

      return (
        <Inline>
          <Radio simple name='OtherCustomer' onChange={this.onInputChange} checked={this.state.OtherCustomer} />
          <DropDown
            name='SelectedCustomerId'
            options={options}
            value={this.state.SelectedCustomerId}
            onChange={this.onInputChange}
            disabled={!this.state.OtherCustomer}
          />
        </Inline>
      )
    }

    const renderCustomerBookingType = () => {
      return (
        <LabelWrapper className='booking-type' labelText={translation(16418).replace('[primaryCustomer]', this.state.Customer.CompanyName)}>
          <Radio
            name='BookingType'
            value='0'
            onChange={this.onInputChange}
            checked={this.state.BookingType === '0'}
            labelText={translation(16410).replace('[primaryCompanyName]', this.state.PrimaryCompanyName)}
          />
          <Radio
            name='BookingType'
            value='1'
            onChange={this.onInputChange}
            checked={this.state.BookingType === '1'}
            labelText={translation(16411).replace('[primaryCompanyName]', this.state.PrimaryCompanyName).replace('[currentCompanyName]', this.props.auth.user.ShopName)}
          />
          <h3>{translation(16419)}</h3>
        </LabelWrapper>
      )
    }

    const renderCustomerInfo = () => {
      let customer = this.state.Customer
      if (customer === undefined) return

      return (
        <Grid cols={'auto auto'} className='customer_info' >
          <div className='col-1'>{translation(30)}</div>
          <div className='first' >{customer.CompanyName}</div>

          <div className='col-1'>{translation(25)}</div>
          <div>{customer.CompanyAddress}</div>

          <div className='col-1'>{translation(41)}</div>
          <div>{customer.CompanyCVR}</div>

          <div className='col-1'>{translation(38)}</div>
          <div>{customer.CompanyPhoneNumber}</div>
        </Grid>
      )
    }

    return (
      <div className='migration'>
        <LabelWrapper labelText={translation(751)}>
          <Divider />
          <h3>{translation(16414).replace('[primaryCompanyName]', this.state.PrimaryCompanyName)}</h3>
          {renderCustomerInfo()}
        </LabelWrapper>
        <LabelWrapper className='customer-selection' labelText={translation(16416)}>
          <Divider />
          <h3>{translation(16415)}</h3>
          <Grid cols='min-content auto'>
            <h3>{translation(47)}</h3>
            <div>
              {renderTopCustomers()}
              {renderCustomerSelect()}
            </div>
            <h3>{translation(48)}</h3>
            <Radio name='NewCustomer' labelText={translation(723)} onChange={this.onInputChange} checked={this.state.NewCustomer} />
          </Grid>
        </LabelWrapper>
        {this.state.SelectedCustomerId > 0 && renderCustomerBookingType()}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    customers: state.common.customers
  }
}

export default connect(mapStateToProps, {
  getCustomerMergeInfo,
  PostCustomerMergeInfo
})(MigrationInfo)



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderActionModal/MigrationInfo/index.js